import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import { Step } from './Step';

import pawIcon from '../../assets/home/welcome/paw.svg';
import checkboxIcon from '../../assets/home/checkbox.svg';
import checkmarkIcon from '../../assets/home/checkmark.svg';
import chevronWhiteRight from '../../assets/chevron-white-right.svg';

import { usePetDemographics } from './hooks';
import { usePostMessage } from '../../hooks';
import { HOME } from '../navigation/routes.constants';
import { POST_MESSAGE_TYPES } from '../../constants';

import styles from './WelcomeContent.module.css';

const WelcomeContent = ({
  goToNextStep = () => { },
}) => {
  const { t } = useTranslation('common');
  const history = useHistory();
  const sendPostMessage = usePostMessage();
  const {
    isWebView,
    userName,
  } = usePetDemographics();

  const onExitClick = () => {
    if (isWebView) {
      // temporarylly closes the webview
      sendPostMessage(POST_MESSAGE_TYPES.CLOSE_PAGE);
    } else {
      // in petcloud, we go to home
      history.push(HOME);
    }
  };

  return (
    <>
      <div className={styles.titleSection}>
        <span className={styles.title}>
          {t('welcome.title', { userName })}
        </span>

        <span className={styles.subtitle}>
          {t('welcome.subtitle')}
        </span>
      </div>

      <div className={styles.steps}>
        <Step icon={pawIcon} translationEntry="welcome.steps.addInformation" />

        <Step
          icon={checkboxIcon}
          translationEntry="welcome.steps.confirmPets"
        />

        <Step
          icon={checkmarkIcon}
          translationEntry="welcome.steps.reviewCoverage"
        />
      </div>

      <button
        className={styles.beginButton}
        onClick={goToNextStep}
        type="button"
      >
        {t('welcome.button')}

        <img alt="" src={chevronWhiteRight} />
      </button>

      <button onClick={onExitClick} type="button">TEMP EXIT</button>
    </>
  );
};

export { WelcomeContent };
